import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from "../main-navbar/navbar.component";
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from "../main-footer/footer.component";


@Component({
  selector: 'app-main-layout',
  imports: [CommonModule, NavbarComponent, RouterOutlet, FooterComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {}
